import { useState, useEffect, useContext, ReactNode } from 'react';
import { DataContext } from 'providers/data';
import { useNavigate, Link } from 'react-router-dom';

import { partners } from 'core/dataPartner';
import { ParamsPageWebView } from 'utils/typeServices';

import { Typography, Box, Collapse } from '@mui/material';

import Modals from 'components/views/Modals';
import ParseWebView from 'components/views/ParseWebView';
import CarouselCars from 'components/views/CarouselCars';
import PhoneCopyWebView from 'components/views/PhoneCopyWebView';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';

import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';
import { ReactComponent as IcDiscoverOtherPlans } from 'assets/icons/ic-discover-other-plans-green.svg';

type Params = {
    checked: boolean;
    children: ReactNode;
}

const CollapseAnimation = ({ checked, children }: Params) => {
    return (
        <Collapse in={checked} {...(checked ? { timeout: 600 } : {})}>
            {children}
        </Collapse>
    )
}

const DiscoverOtherPlans = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const [step, setStep] = useState(0);
    const [isClick, setIsClick] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const [isClickPerfil, setIsClickPerfil] = useState(false);
    const [loadingBtnPerfil, setLoadingBtnPerfil] = useState(false);
    const [showErrorHavePartner, setShowErrorHavePartner] = useState(false);
    const { dataPerfilUser, selectedCar, dataFinancialPending, dataObterDadosCorretorPorPedido, isPendingTicket, customerCars, handleGetPerfilUser, handlePostObterDadosCorretorPorPedido, handlePostFinancialPending } = useContext(DataContext);

    const handlePostFinancialPendingState = () => {
        if (selectedCar) {
            handlePostFinancialPending({
                token: localStorage.getItem('token')!,
                body: {
                    CPF_CNPJ: selectedCar?.NR_CNPJ_CPF,
                    ID_MOTIVO: 0,
                    DS_PLACA: selectedCar?.PLACA || null,
                    CD_PARCEIRO: 1783625,
                    FL_PAGAS: true
                }
            });
        }
    }

    const handleGetPerfilUserState = () => {
        if (dataPerfilUser) {
            navigate('perfil', { state: { sameProfile: true } });
        } else if (typeof dataPerfilUser === "undefined" && selectedCar) {
            setIsClickPerfil(true);
            handleGetPerfilUser({ token: localStorage.getItem('token')!, nrPlatform: selectedCar.NR_PLATAFORMA });
        }
    }

    const handleValidate = () => {
        if (typeof dataPerfilUser === "undefined" && selectedCar) {
            handleGetPerfilUser({ token: localStorage.getItem('token')!, nrPlatform: selectedCar.NR_PLATAFORMA });
        }

        if ((dataObterDadosCorretorPorPedido === undefined) && selectedCar?.CD_PESSOA_PARCEIRO && partners.indexOf(selectedCar?.CD_PESSOA_PARCEIRO) < 0) {
            setLoadingBtn(true);
            handlePostObterDadosCorretorPorPedido({ NR_PLATAFORMA: selectedCar.NR_PLATAFORMA });
        } else {
            if ((typeof isPendingTicket === "undefined") || (typeof isPendingTicket === "undefined" && (customerCars?.length > 1))) {
                setIsClick(true);
                setLoadingBtn(true);
                handlePostFinancialPendingState();
                return;
            }

            if (isPendingTicket === true) {
                setStep(2);
                setIsClick(false);
                return;
            } else if (Array.isArray(dataFinancialPending) && dataFinancialPending?.length >= 0) {
                if (dataPerfilUser && (selectedCar?.NR_TIPO_PRODUTO === 12)) {
                    setStep(1);
                    setIsClick(false);
                    setLoadingBtn(false);
                } else if (typeof dataPerfilUser !== "undefined") {
                    navigate('perfil', { state: { sameProfile: false } });
                } else {
                    setLoadingBtn(true);
                }
            }
        }

    }

    useEffect(() => {
        if ((typeof isPendingTicket === "undefined") || (customerCars?.length > 1)) {
            handlePostFinancialPendingState();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPendingTicket, customerCars]);

    useEffect(() => {
        if (Array.isArray(dataFinancialPending) && dataFinancialPending?.length >= 0) {
            setLoadingBtn(false);
            if (isClick) {
                setStep(1);
                setIsClick(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    useEffect(() => {
        if (dataPerfilUser && isClickPerfil) {
            setLoadingBtnPerfil(false);
            navigate('perfil', { state: { sameProfile: true } });
        } else if (typeof dataPerfilUser !== "undefined") {
            handleValidate();
            setLoadingBtn(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPerfilUser]);

    useEffect(() => {
        if (selectedCar && dataFinancialPending === undefined) {
            handlePostFinancialPendingState();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, dataFinancialPending]);

    useEffect(() => {
        setLoadingBtn(false);
        if (dataObterDadosCorretorPorPedido) {
            setShowErrorHavePartner(true);
        } else {
            setShowErrorHavePartner(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataObterDadosCorretorPorPedido]);

    return (
        <ParseWebView title='Conheça outros planos' link={isWebView ? '/wb/central-de-trocas' : '/central-de-trocas'} isWebView={isWebView} typePage='subpage'>
            <Box sx={{ margin: { xs: '0rem auto 1.375rem', md: '2.375rem auto 1rem' }, textAlign: 'center' }}>
                <CollapseAnimation checked={step !== 2}>
                    <IcDiscoverOtherPlans />
                </CollapseAnimation>
                <CollapseAnimation checked={step === 0}>
                    <Typography sx={{ maxWidth: '25.125rem', fontSize: { xs: '1.125rem', md: '1.25rem' }, margin: '1.1875rem auto 0', lineHeight: '24px' }}>
                        <strong>Selecione o veículo</strong> que deseja conhecer outros planos:
                    </Typography>
                </CollapseAnimation>
                <CollapseAnimation checked={step === 1}>
                    <Typography sx={{ fontSize: { xs: '1.125rem', md: '1.25rem' }, margin: '1.1875rem auto 0', lineHeight: '24px' }}>
                        Esta cotação é para o <strong>mesmo perfil?</strong>
                    </Typography>
                </CollapseAnimation>
            </Box>
            <CollapseAnimation checked={step === 0}>
                <CarouselCars />
                <Box sx={{ display: 'flex', paddingTop: '.5rem', justifyContent: 'center', 'button': { width: '100%', maxWidth: '17.5rem', height: '2.5rem' } }}>
                    <ButtonRectangle name='CONTINUAR' loadingBtn={loadingBtn} onClick={() => handleValidate()} />
                </Box>
            </CollapseAnimation>

            <CollapseAnimation checked={step === 1}>
                <Box sx={{ display: 'flex', gap: '.93rem', alignItems: 'center', flexDirection: 'column', paddingTop: { xs: '0', md: '1.56rem' }, justifyContent: 'center', 'button': { width: '100%', maxWidth: '17.5rem', height: '2.5rem' } }}>
                    <ButtonRectangle name='SIM' loadingBtn={loadingBtnPerfil} onClick={() => handleGetPerfilUserState()} />
                    <ButtonOutlined name='NÃO' onClick={() => navigate('perfil', { state: { sameProfile: false } })} />
                </Box>
                <Box sx={{ display: 'flex', paddingTop: { xs: '2rem', md: '3.625rem' }, flexDirection: 'column', alignItems: 'center' }}>
                    <Typography fontSize='1rem' color='white' fontWeight={700} padding='9px 2.125rem 4px' sx={{ backgroundColor: 'primary.light', width: 'fit-content', marginBottom: '5px' }}>
                        IMPORTANTE:
                    </Typography>
                    <Typography lineHeight='19px' textAlign='center' sx={{ maxWidth: '25.5rem', fontSize: { xs: '.875rem', md: '1rem' }, border: '1.4px solid #17A7E0', borderRadius: '5px', padding: { xs: '.875rem .5rem', md: '.875rem 1.6rem' } }}>
                        O novo plano escolhido só é considerado ativo após a <strong>conclusão da contratação</strong> ou, 
                        caso exija, ao <strong>término da vistoria</strong>.
                    </Typography>
                </Box>
            </CollapseAnimation>


            <CollapseAnimation checked={step === 2}>
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', 'svg': { zIndex: '0' } }}>
                    <IcIturinCoverage />
                    <Typography fontSize='1.875rem' fontWeight={700} color='primary.light' paddingTop='.5rem'>
                        OPSS!
                    </Typography>
                    <Typography fontSize='1.25rem' fontWeight={700} color='primary.light' paddingBottom='1.5625rem'>
                        Parece que há boleto(s) em aberto.
                    </Typography>

                    <Typography fontSize='1.125rem' lineHeight='1.3125rem' textAlign='center' sx={{ 'a': { color: 'primary.light' } }}>
                        Prossiga e conheça outros planos, <br />
                        <strong>mas lembre-se</strong> que você somente poderá optar <br />
                        por algum deles, mediante pagamento dos <br />
                        boleto(s) em aberto.
                        <br />
                        <br />
                        {isWebView ?
                            <>Acesse suas <b>faturas</b> através do menu <br /> inferior do app.</>
                            :
                            <>
                                Deseja regularizar agora?&nbsp;
                                <Link to='/faturas'>
                                    Clique aqui
                                </Link>
                            </>
                        }
                    </Typography>
                    <Box sx={{ maxWidth: '23.56rem', width: '100%', marginTop: '1.5625rem', 'button': { height: '2.5rem', width: '100%', marginBottom: '.9375rem' } }}>
                        <ButtonRectangle name='CONTINUAR' onClick={() => dataPerfilUser ? setStep(1) : navigate('perfil', { state: { sameProfile: false } })} />
                        <ButtonOutlined name='CANCELAR' onClick={() => setStep(0)} />
                    </Box>
                </Box>
            </CollapseAnimation>

            <Modals open={showErrorHavePartner}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: 'auto' } }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1.375rem 1.25rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            AVISO
                        </Typography>
                        <Typography fontSize='.875rem' lineHeight='17px' paddingTop='1rem'>
                            Identificamos que você possui um <strong>parceiro <br />
                                comercial</strong> atrelado!
                            <br />
                            <br />
                            O que deseja fazer para prosseguirmos:
                        </Typography>
                    </Box>

                    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: { xs: '1rem 2.5rem 1.625rem', md: '1rem 3.8125rem 1.625rem' }, 'button': { width: '100%' } }}>
                        {isWebView ?
                            <>
                                <Typography fontSize='.875rem' textAlign='left' color='white' fontWeight={600} paddingBottom='.2rem'>
                                    Falar com parceiro:
                                </Typography>
                                {dataObterDadosCorretorPorPedido && dataObterDadosCorretorPorPedido?.Celular &&
                                    <PhoneCopyWebView text={dataObterDadosCorretorPorPedido?.Celular} link={dataObterDadosCorretorPorPedido?.Celular} />
                                }
                            </>
                            :
                            <ButtonRectangle name='FALAR COM PARCEIRO' onClick={() => navigate('/meus-veiculos/parceiro')} />
                        }
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='SEGUIR POR AQUI' onClick={() => { setShowErrorHavePartner(false); handleValidate(); }} />
                        </Box>
                    </Box>
                </Box>
            </Modals>
        </ParseWebView>
    );
}

export default DiscoverOtherPlans;